<template lang="pug">
  #change-payment
    b-card(header-tag="header")
      template(v-if="isLoading === true")
        loading(:height="200")
      template(v-else)
        b-button.ml-3.mb-2(v-b-modal.order_confirm, variant="outline-success", :disabled="isSendButtonDisabled") 送信する
        b-form-text.ml-3.mb-2.align-left.text-left.error-message-color(v-for="(error_msg, key) of error_msg_list", :key="key") {{error_msg}}
        b-modal#order_confirm(centered, size="ml", title="ご確認", @ok="sendOrder", ok-title="はい", cancel-title="いいえ")
          span 入力内容を送信します。<br>本当によろしいですか？
        b-container(fluid="fluid")
          b-row
            b-col
              .form-inline(:class="title_class")
                h4(:class="title_font_class") ご契約種別・お支払い方法
              .input-div-size(v-if="show_contract_flag === 1")
                b-row.border-top.ml-3.mr-1
                  b-col(:class="customer_title_col_class") ご契約種別
                  b-col(:class="customer_input_col_class")
                    b-form-radio-group.ml-3(:stacked="true", v-model="radio_billing_period.value")
                      b-form-radio.m-1(value="0") 月払い
                      b-form-radio.m-1(value="1") 年間一括払い
                    b-form-text.error-text-position.mb-1.error-message-color.ml-4(v-for="(error_msg) of radio_billing_period.error_msg_list") {{error_msg}}
              .input-div-size(v-else-if="show_contract_flag >= 2")
                b-row.border-top.ml-3.mr-1
                  b-col(:class="customer_title_col_class") ご契約種別
                  b-col(:class="customer_input_col_class")
                    span ご契約種別の変更は
                    a.border-bottom.border-primary(href="https://ssl.neo.co.jp/desknets/cloud/apply/dnservice_modindex/", target="_blank") こちら
                    span よりお問い合わせください。
              .input-div-size(v-else)
                b-row.border-top.ml-3.mr-1
                  b-col(:class="customer_title_col_class") ご契約種別
                  b-col(:class="customer_input_col_class")
                    span 環境構築中です。開通後にお申し込みください。
              b-row.border-top.ml-3.mr-1
                b-col.border-bottom(:class="customer_title_col_class") お支払い方法
                b-col.border-bottom(:class="customer_input_col_class")
                  b-form-radio-group.ml-3(:stacked="true", v-model="radio_payment_type.value")
                    b-form-radio.m-1(value="0") 銀行振込
                    b-form-radio.m-1(value="1") 口座振替
                    b-form-radio.m-1(v-if="this.radio_payment_type.initial_payment === '1'", value="3") 口座情報変更
                    b-form-radio.m-1(value="2") クレジットカード決済
                    b-form-radio.m-1(v-if="this.radio_payment_type.initial_payment === '2'", value="4") クレジットカード情報変更
                  b-form-text.error-text-position.mb-1.error-message-color.ml-4(v-for="(error_msg) of radio_payment_type.error_msg_list") {{error_msg}}
        b-form-text.ml-3 ※月払いの場合の最低契約月数は1カ月となります。
        b-form-text.ml-3 ※銀行振込を選択される場合、振り込み手数料はお客さま負担となります。あらかじめご了承願います。
        b-form-text.ml-3 ※口座振替を選択される場合、お申込みから最短で翌々月の請求分より対応可能です。
        b-form-text.ml-3 ※クレジット決済を選択される場合、サービス開通のタイミングでカード情報登録のメールを案内させていただきます。
        b-form-text.ml-3 &nbsp;&nbsp;必ず、有効期限内でのご登録をお願いいたします。
        b-button.ml-3.mt-2(v-b-modal.order_confirm, variant="outline-success", :disabled="isSendButtonDisabled") 送信する
</template>

<script>
import Api from "@/repositories/api";
import Loading from '@/components/Loading';

const S207PayMethodChangesRepository = Api.get('s207PayMethodChanges')

export default {
  name: "ChangePayment",
  components: {
    Loading
  },
  data() {
    return {
      title_class: "ml-3 customer-title-bg-color pb-1",
      title_font_class: "font-weight-bold pt-2 mb-0",

      customer_title_col_class: "py-2 px-2 border-right font-weight-bold table-title-col-width",
      customer_input_col_class: "py-2 px-2",
      customer_now_data_title_col_class: "py-2 px-2 border-right table-now-data-col-width font-weight-bold",

      customer_now_data_col_class: "py-2 px-2 border-right table-now-data-col-width",

      // 契約種別の出し分けフラグ
      show_contract_flag: 1,

      // ご契約種別
      radio_billing_period: {
        value: "",
        error_msg_list: []
      },

      // お支払い区分
      radio_payment_type: {
        initial_payment: "", // 初期値
        value: "",           // 選択値
        error_msg_list: []   // エラーメッセージ
      },

      // 画面上部のエラーメッセージ
      error_msg_list: [],

      // 読み込み中フラグ
      isLoading: false,

      // 送信ボタン用フラグ
      isSendButtonDisabled: false
    }
  },
  created() {
    // 読み込み中
    this.isLoading = true;

    // S20707_ご契約種別・お支払い方法変更画面表示
    S207PayMethodChangesRepository.get()
    .then((response) => {
      // レスポンスデータ取得
      const arContract = response.data.data

      // 出し分けフラグを設定する
      this.show_contract_flag = arContract['billing_period'].length;

      // 初期値設定
      this.radio_billing_period.value         = arContract['billing_period'][0]; // ご契約種別 ラジオボタン
      this.radio_payment_type.value           = arContract['payment_type'];      // お支払い方法 ラジオボタン
      this.radio_payment_type.initial_payment = arContract['payment_type'];      // お支払い方法 初期値
    })
    .catch((error) =>{
      // httpステータスコードが403の場合（権限エラー）
      if (error.response.status === 403) {
        // アプリケーションエラー画面へ遷移する
        this.$router.push({
          name: 'SupportApplicationError',
          params: {
            // 画面に表示するエラーメッセージ
            error_msg: this.forbidden_message
          }
        })
      }

      // 共通のエラー処理
      this.apiError(error, '画面表示処理', "Support")

      // エラーメッセージをセットする
      this.setErrors(error)
    })
    .finally(() => [
      // 読み込み完了
      this.isLoading = false
    ])
  },
  methods: {
    /**
     * 「送信する」ボタン押下時の処理
     */
    sendOrder() {
      // 「送信する」ボタンをロックする
      this.isSendButtonDisabled = true;

      // リクエストパラメータ作成
      let arRequest = {
        billing_period: this.radio_billing_period.value, // ご契約種別
        payment_type:   this.radio_payment_type.value    // お支払い方法
      }

      // 既存のエラーメッセージをリセット
      this.radio_billing_period.error_msg_list = []; // ご契約種別
      this.radio_payment_type.error_msg_list   = []; // お支払い方法
      this.error_msg_list                      = []; // 画面上部

      // メール送信処理
      S207PayMethodChangesRepository.post(arRequest)
      // 成功した場合
      .then(() => {
        this.$router.push({
          name: 'ShowCustomerInfo',
        })
      })
      // 失敗した場合
      .catch((error) => {
        // 「送信する」ボタンのロックを解除する
        this.isSendButtonDisabled = false;

        // システムエラーが発生していれば、システムエラー画面に遷移する
        this.apiError(error, '画面表示処理', "Support")

        // httpステータスコードが403の場合（権限エラー）
        if (error.response.status === 403) {
          // 画面上部にエラーメッセージを表示する
          this.error_msg_list.push(this.forbidden_message);

          // 画面一番上へスクロールする
          this.pageTopScroll();
        }
        else {
          // エラーリストの読み込み
          const arErrorList = error.response.data.error_list;

          // 各エラーメッセージを画面に埋め込む
          for (let i = arErrorList.length - 1; i >= 0; i--) {
            switch (arErrorList[i].target) {
              case "billing_period":
                this.radio_billing_period.error_msg_list.push(arErrorList[i].error_msg)
                break
              case "payment_type":
                this.radio_payment_type.error_msg_list.push(arErrorList[i].error_msg)
                break
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.customer-title-bg-color {
  background-color: #f5f5f5;
}
.table-title-col-width {
  max-width: 150px;
}
.table-now-data-col-width {
  max-width: 230px;
}
.middle-form-size {
  max-width: 620px;
}
.short-form-size {
  width: 185px;
}
.explanation-remarks {
  margin-bottom: -13px;
}
.now-data-font {
  color: #c0c0c0;
  /*color: #6c757d;*/
}
</style>